export function camelCaseToUnderscore(str?: string) {
  if (!str) return str;
  return str.replace(/(?<![A-Z])(?=[A-Z])/g, "_").toUpperCase();
}
